"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { applicationCountSourceTransformer } from "./applicationCountSourceTransformer";
import { applicationCountSourceTypeTransformer } from "./applicationCountSourceTypeTransformer";
import { jobAverageTimeTransformer } from "./jobAverageTimeTransformer";
import { jobPublishedToFirstApplicationTransformer } from "./jobPublishedToFirstApplicationTransformer";
import { jobFirstApplicationToHiredTransformer } from "./jobFirstApplicationToHiredTransformer";
import { jobCountLocationTransformer } from "./jobCountLocationTransformer";
import { jobCountInternalExternalTransformer } from "./jobCountInternalExternalTransformer";
import { jobCountStateTransformer } from "./jobCountStateTransformer";
import { applicationCountStatusTransformer } from "./applicationCountStatusTransformer";
import { jobRequisitionApprovedToHiredTransformer } from "./jobRequisitionApprovedToHiredTransformer";
import { jobRequisitionRequestedToHiredTransformer } from "./jobRequisitionRequestedToHiredTransformer";
const filterDataByDateRange = (data, dateRange) => {
  const now = /* @__PURE__ */ new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  let startDate;
  let endDate = new Date(currentYear, currentMonth - 1, 1);
  switch (dateRange) {
    case "last_12_months":
      startDate = new Date(currentYear - 1, currentMonth - 1, 1);
      break;
    case "last_3_months":
      startDate = new Date(currentYear, currentMonth - 4, 1);
      break;
    case "last_month":
      startDate = new Date(currentYear, currentMonth - 2, 1);
      endDate = new Date(currentYear, currentMonth - 1, 0);
      break;
    default:
      startDate = new Date(currentYear - 1, currentMonth - 1, 1);
  }
  const filteredData = {};
  Object.entries(data).forEach(([key, value]) => {
    const parts = key.split("_");
    if (parts.length >= 3) {
      const year = parseInt(parts[1]);
      const month = parseInt(parts[2]);
      const keyDate = new Date(year, month - 1, 1);
      if (keyDate >= startDate && keyDate <= endDate) {
        filteredData[key] = value;
      }
    }
  });
  return filteredData;
};
export const transformer = (dataSource, shownAs, groupBy, data, selectedEntities, dateRange = "last_12_months", selectedStatuses = []) => {
  const filteredData = filterDataByDateRange(data, dateRange);
  if (dataSource === "applications") {
    if (shownAs === "count") {
      if (groupBy === "status") {
        return __spreadProps(__spreadValues({}, applicationCountStatusTransformer(filteredData, selectedEntities, selectedStatuses)), {
          chartTitle: "Monthly Applications by Status"
        });
      } else if (groupBy === "source") {
        return __spreadProps(__spreadValues({}, applicationCountSourceTransformer(filteredData, selectedEntities)), {
          chartTitle: "Monthly Applications by Source"
        });
      } else {
        return __spreadProps(__spreadValues({}, applicationCountSourceTypeTransformer(filteredData, selectedEntities)), {
          chartTitle: "Monthly Applications by Source Type"
        });
      }
    } else if (shownAs === "average") {
      if (groupBy === "job_reference") {
        return __spreadProps(__spreadValues({}, jobAverageTimeTransformer(filteredData, selectedEntities)), {
          chartTitle: "Average Applications per Job"
        });
      }
    }
  } else if (dataSource === "jobs") {
    if (shownAs === "count") {
      if (groupBy === "location") {
        return __spreadProps(__spreadValues({}, jobCountLocationTransformer(filteredData, selectedEntities)), {
          chartTitle: "Monthly Jobs by Location"
        });
      } else if (groupBy === "internal_external") {
        return __spreadProps(__spreadValues({}, jobCountInternalExternalTransformer(filteredData, selectedEntities)), {
          chartTitle: "Monthly Jobs by Internal/External"
        });
      } else if (groupBy === "job_state") {
        return __spreadProps(__spreadValues({}, jobCountStateTransformer(filteredData, selectedEntities, selectedStatuses)), {
          chartTitle: "Monthly Jobs by State"
        });
      }
    } else if (shownAs === "average_time") {
      if (groupBy === "published_to_hired") {
        return __spreadProps(__spreadValues({}, jobPublishedToFirstApplicationTransformer(filteredData, selectedEntities)), {
          chartTitle: "Monthly Average Time to Hire from Published Date"
        });
      } else if (groupBy === "first_application_to_hired") {
        return __spreadProps(__spreadValues({}, jobFirstApplicationToHiredTransformer(filteredData, selectedEntities)), {
          chartTitle: "Monthly Average Time to Hire from First Application Date"
        });
      } else if (groupBy === "requisition_approved_to_hired") {
        return __spreadProps(__spreadValues({}, jobRequisitionApprovedToHiredTransformer(filteredData, selectedEntities)), {
          chartTitle: "Average Days from Requisition Approved to Hired"
        });
      } else if (groupBy === "requisition_requested_to_hired") {
        return __spreadProps(__spreadValues({}, jobRequisitionRequestedToHiredTransformer(filteredData, selectedEntities)), {
          chartTitle: "Average Days from Requisition Requested to Hired"
        });
      }
    }
  }
  return {
    labels: [],
    datasets: [],
    chartTitle: "No data available"
  };
};
